'use strict';

module.exports = function (fox) {
  var widgetsContext = require.context('./lib/widgets', true, /\.js$/);
  var templatesContext = require.context('fox-dynamic-injection!fox-template-loader!./lib/templates', true, /\/(?!site)[\w]+\.tpl$/);

  function getDeps(context) {
    context.keys().forEach(function (m) {
      context(m)(fox);
    });
  }

  require('./lib/validator/validator')(fox);

  getDeps(widgetsContext);
  getDeps(templatesContext);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/index.js
// module id = 103
// module chunks = 0